<video #videoElement
  [loop]="loop"
  [muted]="autoplay"
  playsinline
  [attr.poster]="posterLoaded ? poster : null"
  [attr.crop]="crop"
  [attr.preload]="poster ? 'none' : 'metadata'"
>
  <source #videoSourceElement [src]="src" type="video/mp4">
  {{ intl.videoTagUnsupported }}
</video>
<ng-content />
<div class="overlay" [class.visible]="controlsVisible || (playing$ | async) === false || (loading$ | async) === true">
  <kb-progress-indicator
    class="centered"
    design="circular"
    type="indeterminate"
    background="mixed"
    [visible]="(loading$ | async) === true"
    (click)="togglePlaying();"
  />
  <button
    type="button"
    class="toggle-playing centered"
    [class.hidden]="(loading$ | async) === true || secondsMax !== undefined"
    kb-icon icon-uppercase icon-center [icon]="(playing$ | async) ? iconPause : iconPlay"
    [attr.aria-label]="(playing$ | async) ? intl.pauseButtonLabel : intl.playButtonLabel"
    (click)="togglePlaying();"
  ></button>
  <div class="controls">
    @if (secondsMax !== undefined) {
      <kb-seek-slider
        [secondsMax]="secondsMax"
        [secondsNow]="secondsNow"
        [attr.aria-label]="intl.seekSliderLabel"
        #seekSlider
      />
    }
    @if (secondsMax !== undefined || controls === 'minimal') {
      <button
        type="button"
        kb-icon icon-uppercase icon-center [icon]="(playing$ | async) ? iconPause : iconPlay"
        [attr.aria-label]="(playing$ | async) ? intl.pauseButtonLabel : intl.playButtonLabel"
        (click)="togglePlaying();"
      ></button>
    }
    <button
      type="button"
      kb-icon icon-uppercase icon-center [icon]="(muted$ | async) ? iconSoundOff : iconSoundOn"
      [attr.aria-label]="(muted$ | async) ? intl.unmuteButtonLabel : intl.muteButtonLabel"
      (click)="toggleMuted();"
      >
    </button>
    @if (controls === 'minimal' && (loading$ | async) === true) {
      <kb-progress-indicator
        class="hide-fullscreen"
        design="circular"
        type="indeterminate"
        background="mixed"
        [visible]="true"
        (click)="togglePlaying();"
      />
    }
    @if (secondsMax !== undefined) {
      <div class="progress-text">
        <!-- TODO: this does not work well with durations greater than 1 hour -->
        {{ secondsNow | duration | formatDuration:'m:ss' }} / {{ secondsMax | duration | formatDuration:'m:ss' }}
      </div>
    }
    <button
      class="right"
      type="button"
      kb-icon icon-uppercase icon-center [icon]="(fullscreen$ | async) ? iconEndFullscreen : iconFullscreen"
      [attr.aria-label]="(fullscreen$ | async) ? intl.endFullscreenButtonLabel : intl.fullscreenButtonLabel"
      (click)="toggleFullscreen();"
    >
    </button>
  </div>
</div>
